import React, {PureComponent} from "react"

import {Deal} from "@irati/types"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import DealSavingsTypes from "@irati/deals/types/enums/DealSavingsType"

import SpecialRates from "./SpecialRates"
import Free from "./Free"
import Amount from "./Amount"
import SavingsWrapper from "./styled/SavingsWrapper"

interface Props {
  deal: Deal,
  size?: "small" | "extra-small",
  addSavingsTypeEmoji?: boolean,
  smallSavingsHeader?: boolean,
  allowEarnPointsModal?: boolean,
  isMobile?: boolean
}

class Saving extends PureComponent<Props> {
  render() {
    const {addSavingsTypeEmoji, deal, smallSavingsHeader, allowEarnPointsModal, isMobile} = this.props
    if (!deal) {
      return null
    }
    const {userSavings} = deal.savings

    const idNamespace = id("saving", this.props)
    const birthdayEmoji = addSavingsTypeEmoji ? "🎂" : ""

    let savingsBlock = null

    if (userSavings.type === DealSavingsTypes.SPECIAL_RATES) {
      savingsBlock = <SpecialRates id={id("special-rates", idNamespace)} small={smallSavingsHeader} />
    } else if (userSavings.type === DealSavingsTypes.FREE) {
      savingsBlock = <Free id={id("free", idNamespace)} emoji={birthdayEmoji} small={smallSavingsHeader} />
    } else if (userSavings.value) {
      savingsBlock = (
        <Amount
          deal={deal}
          idNamespace={idNamespace}
          small={smallSavingsHeader}
          allowEarnPointsModal={allowEarnPointsModal}
          isMobile={isMobile} />
      )
    }

    return (
      <SavingsWrapper id={id("savings-wrapper", idNamespace)} data-test="savings">
        {savingsBlock}
      </SavingsWrapper>
    )
  }
}

export default injectIntl(Saving)
